import * as actions from '../actions/actionTypes';
import { IPauseResumeState } from '../types/IPauseResume';
import { AnyAction } from 'redux';

const initialState: IPauseResumeState = {
    isPaused: null
}

const pauseResume = ( state: IPauseResumeState = initialState, action: AnyAction ) : IPauseResumeState => {
    switch (action.type) {



        // todo
        // lets reload the location on resume if the app was paused for at least 10 seconds as a first step
        // finally we want to stop/start all network requests and timers
        case actions.PAUSE_APP:
            return { isPaused: Date.now() }
        case actions.RESUME_APP:
            if((Date.now() - state.isPaused) > 10000) {
                document.location.reload()
            }
            return { isPaused: null }



        default:
            return state
    }
}

export default pauseResume
